export const enDirectorReportTranslations = {
    DIRECTOR_REPORT__TITLE: 'Director report',
    DIRECTOR_REPORT__DESCRIPTION: 'Send the analytics summary to an external recipient (the director).',
    DIRECTOR_REPORT__EMAIL_LABEL: 'Director email',
    DIRECTOR_REPORT__EMAIL_PLACEHOLDER: 'director@example.com',
    DIRECTOR_REPORT__PERIOD_LABEL: 'Period (optional)',
    DIRECTOR_REPORT__SEND_WEEKLY: 'Send weekly report',
    DIRECTOR_REPORT__SEND_MONTHLY: 'Send monthly report',
    DIRECTOR_REPORT__SUCCESS: 'The report has been queued and will be sent to {email}',
    DIRECTOR_REPORT__ERROR_INVALID_EMAIL: 'Please check the email address',
    DIRECTOR_REPORT__ERROR_GENERIC: 'Failed to send. Please try again later',
};
